import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'Tax';
const ENDPOINT = `/taxes/`;

@Injectable({
    providedIn: 'root'
})
export class TaxesService extends ServiceBase {

    // Pas de cache : le back filtre les taxes sur le pays du dossier (`TaxViewSet.list`),
    // un cache clé par URL resservirait donc celles du dossier précédent (#173).

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
